export default "__VITE_ASSET__jlbkFotq__"